"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var makeTextStyling_1 = __importDefault(require("./makeTextStyling"));
var Text = function (_a) {
    var children = _a.children, id = _a.id, variant = _a.variant, align = _a.align, dataTestId = _a.dataTestId;
    var textStyles = (0, makeTextStyling_1.default)({ variant: variant });
    var muiComponents = {
        footer: 'p',
        header: 'h5',
        summary: 'span',
        note: 'p',
        question: 'h6',
        text: 'p',
        listItem: 'p',
        listItemWithSubtext: 'p',
        listItemSubtext: 'p',
        tileItem: 'p',
        tileItemSubtext: 'p',
        contentWithList: 'span',
        tickedList: 'span',
    };
    return ((0, jsx_runtime_1.jsx)(Typography_1.default, __assign({ "data-testid": dataTestId || 'text', id: id, align: align, component: muiComponents[variant], css: textStyles }, { children: children })));
};
Text.defaultProps = defaultProps_1.default;
exports.default = Text;
//# sourceMappingURL=Text.js.map